import React, { useState, useEffect } from "react";
import { Tabs, Input, Button } from "antd";
import FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import NetworkService from "../services/NetworkService";
import { Link } from "react-router-dom";

import { activeCC, activeREC, templateView } from "../assets/tableViews";
import "react-pdf/dist/esm/Page/TextLayer.css";

import { useAtom } from "jotai";
import { accessTokenAtom } from "../atoms";
import TemplateTable from "../components/TemplateTable";
import { useMsal, useAccount } from "@azure/msal-react";
import { graphrequest, loginRequest } from "../authConfig";

function EmailTemplate() {
  const [accessAtom, setAPIAtom] = useAtom(accessTokenAtom);
  const [currentTabTitle, setCurrentTabTitle] = useState("Active CC");
  const [templates, setTemplates] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [accessToken, setAccessToken] = useState();

  useEffect(() => {
    async function getData() {
      if (account) {
        instance
          .acquireTokenSilent({
            ...loginRequest,
            account: account,
          })
          .then((response) => {
            console.log("CH", response);

            setAccessToken(response.accessToken);
            return response.accessToken;
          })
          .then((token) => {
            const networkServiceObj = new NetworkService();
            networkServiceObj
              .getCertificateEmailTemplateService(token)
              .then((res) => {
                setCurrentData(res.data);
                setTemplates(res.data);
                setLoading(false);
              })
              .then(() => setLoading(false));
          });
      }
    }
    setLoading(true);
    getData();
  }, []);

  return (
    <div className="App" style={{ overflowX: "auto", width: "50%", margin: "auto", marginTop: 50 }}>
      {/* {loading==false &&  <Tabs defaultActiveKey='1' items={secondTab} onChange={handleTabChange} destroyInactiveTabPane={true}></Tabs>} */}
      {loading === false ? (
        <TemplateTable
          defaultColumns={templateView}
          dummyData={templates}
          label={"Email"}
          token={accessToken}
        ></TemplateTable>
      ) : null}
    </div>
  );
}

export default EmailTemplate;
